export default "__VITE_ASSET__DyaLT9oo__"